import LoadingButton from '@mui/lab/LoadingButton';
import { Box, Chip, styled, Typography, Alert } from '@mui/material';
import { format, isFuture } from 'date-fns';
import React from 'react';

const BookingButton = styled(LoadingButton)(({ theme }) => ({
    padding: '10px 0px',
    margin: '10px auto',
    width: '100%',
    maxWidth: '150px',
    borderRadius: '30px',
}));

export const SubscriptionCard = props => {
    return (
        <Box
            sx={{
                boxShadow: '2px 2px 15px 0 #b3bac7',
                padding: '20px',
                maxWidth: '300px',
                borderRadius: '10px',
            }}
        >
            <Typography variant="h5" sx={{ height: '64px' }}>
                {props.name}
            </Typography>
            {props.selected === true ? (
                <div>
                    {props.planStatus === 'Cancelled' ? (
                        <Box />
                    ) : (
                        <Box sx={{ padding: '10px' }}>
                            <Chip label="Current Plan" />
                        </Box>
                    )}
                </div>
            ) : (
                <Box sx={{ height: '52px' }}></Box>
            )}

            <Box>{props.descriptionComponent}</Box>
            <Typography sx={{ padding: '10px' }} variant="h6">
                ${props.amount / 100} per {props.interval}
            </Typography>
            {props.selected === true ? (
                <Chip
                    sx={{ padding: '10px', margin: '10px' }}
                    label={props.planStatus}
                    color="primary"
                />
            ) : (
                <Box sx={{ height: '52px' }}></Box>
            )}

            {(props.planStatus === 'Pending' ||
                props.planStatus === 'Active') &&
            typeof props.trialEnd !== 'undefined' &&
            props.name === 'Standard School Subscription' &&
            isFuture(new Date(0).setUTCSeconds(props.trialEnd)) ? (
                <Typography>
                    {`Trial End: ${format(
                        new Date(0).setUTCSeconds(props.trialEnd),
                        'dd/MM/yyyy'
                    )}`}
                </Typography>
            ) : (props.planStatus === '' ||
                  typeof props.planStatus === 'undefined') &&
              props.name !== 'Pay as you Go Subscription' ? (
                <>
                    <Alert severity="info">{`Exclusive offer: airTeachr usage Free for ${process.env.REACT_APP_trial_period}!`}</Alert>
                </>
            ) : (
                <dev />
            )}
            {(props.subscriptionType === '' ||
                typeof props.subscriptionType === 'undefined' ||
                props.planStatus === 'Cancelled') && (
                <Box>
                    {/* {props.selected !== true && ( */}
                    <BookingButton
                        variant={
                            props.subscribeText === 'Selected'
                                ? 'contained'
                                : 'outlined'
                        }
                        onClick={props.addSubscription}
                    >
                        {props.subscribeText}
                    </BookingButton>
                    {/* )} */}
                </Box>
            )}
        </Box>
    );
};

export default SubscriptionCard;
